import { TruckCargoContainerIcon } from './TruckCargoContainerIcon';

/**
 * author: Colton Wiscombe
 * id 8C535C82-EAA1-431A-90AE-D0A5032024EB
 * name truck-cargo-container
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-cargo-container.svg
 * tags
 * - Transportation + Road 
 */
export const TruckShippingIcon = TruckCargoContainerIcon;
export default TruckShippingIcon